/**
 * Захват источника трафика первого касания на клиенте (ТЗ §6.2).
 * Снимает UTM/yclid/referrer/landing при первом заходе; ClientID запрашивается
 * позже, в момент оформления заказа (когда счётчик уже инициализирован)
 */
export default defineNuxtPlugin({
  name: 'attribution:plugin',
  dependsOn: ['alt-container:plugin'],
  parallel: true,
  setup() {
    const { captureFirstTouch } = useAttribution()
    captureFirstTouch()
  },
})
